export default __webpack_public_path__ + "static/custos2-60c5ebc3e4d8a10789ae5fd8370b4b78.jpeg";